module.exports = __webpack_public_path__ + "static/media/Women.b84ac966.svg";